export function zEmptyStringAsNull<T>(val: T): T | null {
    return val === '' ? null : val;
}
